import get from 'lodash/get';
import ProductBadgeYear from '@/components/containers/plp/ProductCard/ProductBadgeYear';
import ProductCompareButton from '@/components/containers/plp/ProductCard/ProductCompareButton';
import Swatches from '@/components/Swatches';
import {Url} from '@/utils/url';

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    compareButtonEnabled: {
      type: Boolean,
      default: true,
    },
    itemId: {
      type: Number,
      default: 0,
    },
  },

  components: {
    ProductBadgeYear,
    ProductCompareButton,
    Swatches,
  },

  computed: {
    productUrl() {
      if (!this.product.url) {
        return '';
      }

      let url = Url.withContextPath(this.product.url);
      if (this.currentColor && this.currentColor.length > 0) {
        url += `${url.indexOf('?') > -1 ? '&' : '?'}colorCode=${this.currentColor}`;
      }

      return url;
    },

    swatches() {
      let result = [];

      if (!this.product.colorSwatchImageUrl) {
        return result;
      }

      for (let item of this.product.colorSwatchImageUrl) {
        let index = item.indexOf('_url=');
        if (index < 0) {
          continue;
        }

        result.push(item.substring(0, index));
      }

      return result;
    },

    price() {
      let result = {
        sale: `${this.product.productPriceRange} ${this.bp('excludeTaxText')}`,
        adv: '',
      };

      if (this.product.wasPriceRange && this.product.wasPriceRange !== this.product.productPriceRange) {
        result.adv = `${this.product.wasPriceRange} ${this.bp('excludeTaxText')}`;
      }

      return result;
    },

    isCustomizeVisible() {
      return this.customize && this.product.projectOneUrl;
    },

    isCompareButtonVisible() {
      return this.compareButtonEnabled && !this.product.isArchived;
    },
  },

  methods: {
    changeImage(color) {
      this.currentColor = color;
      if (!this.product.colorSwatchImageUrl) {
        return;
      }

      for (let item of this.product.colorSwatchImageUrl) {
        const keyword = `${color}_url=`;
        if (item.indexOf(keyword) > -1) {
          this.currentImageUrl = item.substring(keyword.length);
          return;
        }
      }

      // Fallback to primary image
      this.setPrimaryImage();
    },

    setPrimaryImage() {
      if (!this.product.colorSwatchImageUrl) {
        this.currentImageUrl = get(this.product, 'imageURLList[0]', window.ACC.config.productNoImageUrl);
      }
    },
  },

  mounted() {
    this.setPrimaryImage();
  },

  data() {
    return {
      currentImageUrl: '',
      currentColor: '',
    };
  },
};
